import { ApiClient } from '@bustickus/api';
import { IClientCityBrief } from '@bustickus/models-client';
import { createApiAddress } from 'common/helpers';

class ApiCities {
  private readonly client: ApiClient = ApiClient.getInstance();
  private static instance: ApiCities | null = null;

  private constructor() {}

  static getInstance(): ApiCities {
    if (ApiCities.instance == null) {
      ApiCities.instance = new ApiCities();
    }

    return ApiCities.instance;
  }

  async getAll(): Promise<IClientCityBrief[]> {
    const address = createApiAddress('/client/cities');
    const response = await this.client.sendRequest<IClientCityBrief[]>('get', address);
    return response;
  }
}

export default ApiCities;
